var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.17001 6.50452C7.82171 6.72598 7.41713 6.84304 7 6.84304C6.5829 6.84304 6.17832 6.72598 5.83002 6.50452L0.0932148 2.85693C0.0613867 2.8367 0.0303789 2.8156 0 2.7939V8.77087C0 9.45615 0.583105 10 1.28879 10H12.7112C13.4297 10 14 9.44389 14 8.77087V2.79388C13.9695 2.81563 13.9385 2.83678 13.9066 2.85704L8.17001 6.50452Z",
    fill: "#D8D8D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.548242 2.20598L6.28504 5.85359C6.50221 5.99168 6.75109 6.0607 6.99997 6.0607C7.24888 6.0607 7.49779 5.99165 7.71496 5.85359L13.4518 2.20598C13.7951 1.98784 14 1.62275 14 1.22871C14 0.551182 13.422 0 12.7116 0H1.28836C0.577965 2.60779e-05 0 0.551208 0 1.22936C0 1.62275 0.204969 1.98784 0.548242 2.20598Z",
    fill: "#D8D8D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.798d99908f6b50abf660697159b9b047.svg";
export { ForwardRef as ReactComponent };